import React from "react";
import { Icon, Typography, Grid } from "@mui/material";
import { Chat } from "@mui/icons-material";
import { PropertyUseCaseType } from "./use-case-form";

const UseCaseDetailsShort: React.FC<{useCase:PropertyUseCaseType}> =
({
  useCase,
}) => <Grid size={{ xs: 12, sm: 9, xl: 10 }}>
  <Typography variant="h6">
    <Icon fontSize="small"><Chat /></Icon> {useCase.useCase.friendlyName}
  </Typography>
  <Typography variant="subtitle2">
    <strong>Subaccount:</strong> {useCase.applicationIdFriendlyName}
  </Typography>
  <Typography variant="subtitle2">
    <strong>Message Group or Number:</strong> {useCase.messageIdFriendlyName}
  </Typography>
  <Typography variant="subtitle2">
    <strong>SMS Prefix:</strong> {useCase.smsPrefix || "Default"}
  </Typography>
  <Typography variant="subtitle2">
    <strong>Active:</strong> {useCase.active ? "Yes" : "No"}
  </Typography>
</Grid>;

export default UseCaseDetailsShort;
